import React from 'react';
import {FieldArray, FieldArrayConfig, FieldArrayRenderProps} from "formik";
import {LevelData} from "types/Level";
import LevelForm from "./LevelForm";
import Button from 'components/Button';
import { PlusIcon } from '@heroicons/react/solid';

// Helpers ----

const newLevel = {
  name: '',
  description: '',
  accessibility_criteria: [],
  area: undefined,
}

// Component ----

type LevelListFieldProps = FieldArrayConfig & {
  areaName: string
}

function LevelListField({areaName, ...props}: LevelListFieldProps) {
  return (
    <FieldArray {...props}>
      {(helpers: FieldArrayRenderProps) => {

        const {push, form} = helpers
        const levelData = form.values[props.name] as Array<LevelData> | undefined

        return (
          <div>
            <ul>
              {levelData?.map((level, index) => (
                <li key={index} className="my-4">
                  <LevelForm
                    siteArea={form.values[areaName]}
                    level={level}
                    index={index}
                    helpers={helpers}
                  />
                </li>
              ))}
            </ul>

            <div className={(levelData && levelData.length < 1) ? 'mt-0' : 'mt-4'}>
              <Button
                color={Button.colors.SECONDARY}
                icon={PlusIcon}
                size={Button.sizes.X_SMALL}
                onClick={() => push({...newLevel, number: (levelData || []).length + 1})}
              >
                Add Level
              </Button>
            </div>
          </div>
        )
      }}
    </FieldArray>
  );
}

export default LevelListField;